import React from 'react';
import { Icon, useTheme } from '@Sage/hoi-poi-ui';

const SenderDomainVerifiedCell = (params) => {
    const theme = useTheme();
    const { data } = params;
    const verified = Boolean(data?.domainVerified);

    return (
        <div className="sender-domain-verified-cell">
            <Icon
                name={verified ? 'taskCheckedOutline' : 'close'}
                size="large"
                color={
                    verified ? theme.colors.semantic.positive500 : theme.colors.semantic.negative500
                }
            />
        </div>
    );
};

SenderDomainVerifiedCell.displayName = 'SenderDomainVerifiedCell';

export default SenderDomainVerifiedCell;
